 import * as constants from './constants';
 import userRequest, {
     userApi
 } from 'common/request';
 import { Toast } from 'antd-mobile';
 const showToast = (data) => {
     Toast.info(data, 1);
 }
 const changeSubjectInfo = (subjectInfo, resource) => ({
     type: constants.CHANGE_SUBJECT_INFO,
     subjectInfo,
     resource
 });
 const changeQuestionList = (questionList) => ({
     type: constants.CHANGE_QUESTION_LIST,
     questionList,
 });
 const changeUserQuestionList = (userQuestionList) => ({
     type: constants.CHANGE_USER_QUESTION_LIST,
     userQuestionList,
 });
 const changeOtherQuestionList = (otherQuestionList) => ({
     type: constants.CHANGE_OTHER_QUESTION_LIST,
     otherQuestionList,
 })
 const getFinishedList = (finishedList) => ({
     type: constants.CHANGE_FINISHEDLIST,
     finishedList
 })
 const getFinishedListLock = (finishedListLock) => ({
    type: constants.CHANGE_FINISHEDLIST_LOCK,
    finishedListLock
})
 const getFinishedPeriod = (finishedPeriod) => ({
     type: constants.CHANGE_PLAY_TIME,
     finishedPeriod
 })
 const getPop= (pop) => ({
    type: constants.CHANGE_POP,
    pop
})

 export const getSubjectInfo = (course_id, sub_id) => {
     return (dispatch) => {
         userRequest.get(window.AppConfig.mainIP + userApi.getSubjectInfo, {
             course_id,
             sub_id
         }).then((res) => {
             if (res.code === 0) {
                console.log('res.data.content.resource',res.data,res.data.content.resource)
                 if (res.data.content.resource ) {
                    let resource ={}
                    try
                      {
                      //在这里运行代码
                         resource = JSON.parse(res.data.content.resource);
                      }
                    catch(err)
                      {
                      //在这里处理错误
                       resource ={}
                      }
                    dispatch(changeSubjectInfo(res.data, resource))

                 }else{
                    dispatch(changeSubjectInfo({}, {}))
                    dispatch(changeSubjectInfo({}, ''))
                 }
             }
         })
     }
 }
 //获取问答列表
 export const getQuestionList = (course_id, user_id, getstatus) => {
     return (dispatch) => {
         if (getstatus === 'user') {
             userRequest.get(window.AppConfig.mainIP + userApi.getQuestionList, {
                 course_id,
                 no_answer: 0,
                 user_id: user_id
             }).then((res) => {
                 if (res.code === 0) {

                     dispatch(changeUserQuestionList(res.data))
                 } else {
                     dispatch(changeUserQuestionList([]))
                 }
             })
         } else if (getstatus === 'other') {
             userRequest.get(window.AppConfig.mainIP + userApi.getQuestionList, {
                 course_id,
                 no_answer: 0
             }).then((res) => {
                 if (res.code === 0) {
                     let otherData = [];
                     res.data.map((item, index) => {
                         if (item.userid != user_id) {
                             otherData.push(item)
                         }
                     })
                     dispatch(changeOtherQuestionList(otherData))
                 } else {
                     dispatch(changeOtherQuestionList([]))
                 }
             })
         }

     }
 }


 export const getUserInfo = () => {
     return (dispatch) => {
         let userinfo = JSON.parse(localStorage.getItem("userinfo")||"{}");
         return userinfo
     }
 }
 export const getUserValue = (name) => {
     return (dispatch) => {
         let userinfo = JSON.parse(localStorage.getItem("userinfo")||"{}");
         if (userinfo.hasOwnProperty(name)) {
             return userinfo[name]
         } else {
             return '游客' + Math.round(Math.random());
         }
     }

 }
 export const getUserQuestionList = (course_id) => {
     return (dispatch) => {
         let user_id = dispatch(getUserValue('user_id'))
         dispatch(getQuestionList(course_id, user_id, 'user'))

     }
 }
 export const getOtherQuestionList = (course_id) => {
     return (dispatch) => {
         let user_id = dispatch(getUserValue('user_id'))
         dispatch(getQuestionList(course_id, user_id, 'other'))
     }
 }
 //添加问题

 export const addQuestion = (content, course_id) => {
     return (dispatch) => {
         let user_id = dispatch(getUserValue('user_id'));
         let username = dispatch(getUserValue('user_name'));
         userRequest.post(window.AppConfig.mainIP + userApi.addQuestion, {
             user_id,
             content,
             username,
             course_id
         }).then((res) => {

             if (res.code === 0) {
                 dispatch(getUserQuestionList(course_id))
             }
         })
     }
 }

 export const recordCreate = (bodyData) => {
    return async dispatch => {
        const initData = {
            username: JSON.parse(localStorage.getItem('userinfo')).user_name,
            tenant_code: String(localStorage.getItem('tenant_code')),
            update_at: +String(parseInt(Date.now() / 1000))
        }
        // window.AppConfig.courseHost
        return await userRequest.postRequest( window.AppConfig.courseHost + userApi.recordCreate, {...bodyData, ...initData})
        .then(res => {
            console.log(res)
        }).catch(err => {
            console.log(err)
        })
    }
 }

 // 查看课程章节是否已学过
 export const getFinishedCourse = (course_id, user_id) => {
   return (dispatch) => {
     userRequest.get(window.AppConfig.mainIP + userApi.courseListFinished, {
       "type": "learned", "get_sub_list":"1", course_id, user_id
     }).then((res) => {
       if (res.success === true && res.result.data.length > 0) {
         dispatch(getFinishedList(res.result.data))
       }
     })
   }
 }

// 后面的修改，查看章节是否学过然后是否解锁
export const getFinishedCourseLock = (course_id, account) => {
    let tid = JSON.parse(localStorage.getItem('userinfo')).tenant
    return (dispatch) => {
      userRequest.get(window.AppConfig.mainIP + userApi.courseListFinishedLock + course_id, {
          "tid": tid, "username": account
      }).then((res) => {
        if (res.code === 200 && res.data.data.length > 0) {
            dispatch(getFinishedListLock(res.data.data))
        }
      })
    }
 }

 export const getFinishedPlaytime = (course_id, user_id, sub_id) => {
     return (dispatch) => {
        userRequest.get(window.AppConfig.mainIP + userApi.courseListFinished, {
             "type": "learn_time", "sort_update_desc": "1", user_id, course_id, sub_id
         }).then((res) => {
             if(res.success === true && res.result.data.length >= 0) {
                dispatch(getFinishedPeriod(res.result.data))
             }
         })
     }
 }
